const iconPicker = {
  pickIcon: "Выбрать иконку",
  emoji: "Эмодзи",
  icons: "Иконки",
  image: "Изображение",
  search: "Поиск...",
  all: "Все",
  remove: "Удалить иконку",
  uploadFile: "Загрузить изображение",
  uploading: "Загрузка...",
  orPasteUrl: "Или вставьте URL изображения",
  apply: "Применить",
  noResults: "Нет результатов",
  phosphor: "Phosphor",
  weight: "Толщина",
  weightThin: "Тонкий",
  weightLight: "Лёгкий",
  weightRegular: "Обычный",
  weightBold: "Жирный",
  weightFill: "Заливка",
  size: "Размер",
  sizeAuto: "Авто",
  weightDuotone: "Двухтоновый",
} as const;
export default iconPicker;
